import {BaseService} from "./base.service";

class MembersService extends BaseService {

    constructor() {
        super('membresias')
    }

    getMembers(params = {}) {
        return this.http.post(`api/search-members`, params).then(response => response.data).catch(err => err.message);
    }

}

export const membersService = new MembersService();
